import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileLanguagePreferences.scss'
import * as commonStyles from '../../../common/_common.scss'
import { modificationStates } from '../../../common/ReducerHelperFunctions/listDifferenceComputer'
import React from 'react';

const AdviserProfileLanguagePreferences = ({
  languages,
  children
}) => (
  <div>
    <h4 className={styles['title']}>Languages {children}</h4>
    <ul className={styles['list']}>
      {(languages || []).length <= 0 && <li>Not specified</li>}
      {(languages || []).map(function (language, i) {
        if (language.modificationState === modificationStates.deleted) {
          return <li key={i} className={commonStyles['item-deleted']}> {language.language} </li>
        } else if (language.modificationState === modificationStates.added) {
          return <li key={i} className={commonStyles['item-added']}> {language.language} </li>
        }
        return (<li key={i}> {language.language} </li>)
      })}
    </ul>
  </div>
)

AdviserProfileLanguagePreferences.propTypes = {
  languages: PropTypes.array.isRequired,
  children: PropTypes.object
}

export default (AdviserProfileLanguagePreferences)
